import styled from "styled-components";

export const CalenderStyled = styled.div`
  background-color: white;
  border-radius: 5px;
  max-width: 400px;
  /* min-width: 325px; */
  padding: 5px 10px;
`;
